__turbopack_context__.v({
  "getAppMarkets": "style-module-scss-module__k7sEAG__getAppMarkets",
  "marketImage": "style-module-scss-module__k7sEAG__marketImage",
});
